export default function sessionKeyExists(partialKey: string): boolean {
  for (let i = 0; i < sessionStorage.length; i++) {
    const key = sessionStorage.key(i);
    if (key && key.includes(partialKey)) {
      return true;
    }
  }
  return false;
}
